import { useState } from "react";
import toast from "react-hot-toast";
import "../styles/contact.css";

const defaultFormState = {
  name: "",
  email: "",
  subject: "",
  message: "",
  company: "",
};

export default function Contact() {
  const [form, setForm] = useState(defaultFormState);
  const [loading, setLoading] = useState(false);

  const onChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        message: form.subject
          ? `Subject: ${form.subject}\n\n${form.message}`
          : form.message,
        company: form.company,
      };

      const res = await fetch("/api/support/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const detail = await res.text();
        throw new Error(detail || "Failed to send");
      }

      toast.success("Message sent");
      setForm(defaultFormState);
    } catch (error) {
      console.error("Contact form submit failed", error);
      toast.error("Couldn't send message. Email info@pebbledash.co.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pd-contact-page">
      <section className="pd-section pd-contact-hero">
        <div className="pd-container">
          <h1 className="pd-h2">Contact Us</h1>
          <p className="pd-lead">
            We’re here to help. Whether you have a question about features, pricing,
            onboarding, or anything else, our team will respond as soon as possible.
          </p>
        </div>
      </section>

      <section className="pd-section pd-contact-body">
        <div className="pd-container pd-contact-grid">
          <form className="pd-contact-form" onSubmit={onSubmit}>
            <div className="pd-form-group">
              <label htmlFor="pd-contact-name">Name</label>
              <input
                id="pd-contact-name"
                type="text"
                placeholder="Your name"
                value={form.name}
                onChange={onChange("name")}
                required
              />
            </div>

            <div className="pd-form-group">
              <label htmlFor="pd-contact-email">Email</label>
              <input
                id="pd-contact-email"
                type="email"
                placeholder="you@company.com"
                value={form.email}
                onChange={onChange("email")}
                required
              />
            </div>

            <div className="pd-form-group">
              <label htmlFor="pd-contact-subject">Subject</label>
              <input
                id="pd-contact-subject"
                type="text"
                placeholder="How can we help?"
                value={form.subject}
                onChange={onChange("subject")}
              />
            </div>

            <label className="pd-form-group" style={{ display: "none" }} aria-hidden>
              {/* Honeypot field for bots */}
              <span>Company</span>
              <input
                tabIndex={-1}
                autoComplete="off"
                name="company"
                value={form.company}
                onChange={onChange("company")}
              />
            </label>

            <div className="pd-form-group">
              <label htmlFor="pd-contact-message">Message</label>
              <textarea
                id="pd-contact-message"
                placeholder="Write your message…"
                rows={6}
                value={form.message}
                onChange={onChange("message")}
                required
              />
            </div>

            <button className="pd-btn pd-btn--primary" type="submit" disabled={loading}>
              {loading ? "Sending…" : "Send Message"}
            </button>
          </form>

          <div className="pd-contact-info">
            <div>
              <h3 className="pd-h3">Get in touch</h3>
              <p className="pd-muted">Our team typically responds within 1–2 working days.</p>
            </div>

            <ul className="pd-contact-list">
              <li>
                <strong>Email</strong>
                <br />
                info@pebbledash.co
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
